import { resolveUpdate } from './resolve';

export const createContactsSlice = (set) => ({
  // ── Gestion des prospects/clients ──
  contacts: [],
  setContacts: (suivant) => set((etat) => ({ contacts: resolveUpdate(suivant, etat.contacts) })),
  contactsLoaded: false,
  setContactsLoaded: (suivant) =>
    set((etat) => ({ contactsLoaded: resolveUpdate(suivant, etat.contactsLoaded) })),
  contactFilter: 'prospect', // 'prospect'|'actif'|'inactif'|'all'
  setContactFilter: (suivant) =>
    set((etat) => ({ contactFilter: resolveUpdate(suivant, etat.contactFilter) })),
  contactSearch: '',
  setContactSearch: (suivant) =>
    set((etat) => ({ contactSearch: resolveUpdate(suivant, etat.contactSearch) })),
  contactRevenueSort: null, // null | 'asc' | 'desc' — tri colonne C.A cumulé
  setContactRevenueSort: (suivant) =>
    set((etat) => ({ contactRevenueSort: resolveUpdate(suivant, etat.contactRevenueSort) })),
  contactModal: null, // null | client en édition/création
  setContactModal: (suivant) =>
    set((etat) => ({ contactModal: resolveUpdate(suivant, etat.contactModal) })),
  contactEdit: null, // édition inline contacts : { id, field }
  setContactEdit: (suivant) =>
    set((etat) => ({ contactEdit: resolveUpdate(suivant, etat.contactEdit) })),
});
